import PropTypes from "prop-types";
import {Fragment} from "react";

const PackageOverview = (props) => {
    const iconSrc = props?.iconSrc || '';
    const title = props?.title || '';
    const price = props?.price || 0;
    const basePrice = props?.basePrice || 0;
    const shortDescription = props?.shortDescription || '';
    const onClickGetStarted = props?.onClickGetStarted || (() => {});
    const isLoading = props?.loading || false;
    const isFromMobileApp = props?.isFromMobileApp || false;

    return (
        <div className="package-overview margin-1-rem">
            <div className="package-overview__header">
                <div className="package-overview__image-wrapper">
                    <img
                        src={iconSrc}
                        alt="packageImg"
                        className="package-overview__image"
                    />
                </div>

                <h3 className="package-overview__title">{title}</h3>
                <div className="package-overview__price-wrapper">
                    <p className="package-overview__base-price">${basePrice}</p>
                    <p className="package-overview__current-price">${price}</p>
                </div>

                {
                    isFromMobileApp
                        ? (
                        <Fragment></Fragment>
                        ) : (
                            <button
                                className="package-overview__button"
                                onClick={onClickGetStarted}
                                disabled={isLoading}
                            >
                                {isLoading
                                    ? (
                                        <>
                                            <i className="fa fa-spinner fa-spin"/>&nbsp;&nbsp;<span>Loading...</span>
                                        </>
                                    )
                                    : 'Get Started'
                                }
                            </button>
                        )
                }

                </div>
            <div className="package-overview__details flex-grow-1">
                <p className="package-overview__description">
                    <p dangerouslySetInnerHTML={{ __html: shortDescription }} />
                </p>
            </div>
        </div>
    )
}

PackageOverview.propTypes = {
    iconSrc: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    basePrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    packageDetails: PropTypes.string,
    onClickGetStarted: PropTypes.func,
};

export default PackageOverview;
